import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import CalculateIcon from '@mui/icons-material/Calculate';
import { API_BASE } from '../config';
import usePageTitle from '../shared/hooks/usePageTitle';

export default function TabulatorDashboard() {
  usePageTitle('OSSDF Tabulator');
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3,
        p: 4,
        bgcolor: 'background.default',
      }}
    >
      <CalculateIcon color="primary" sx={{ fontSize: 64 }} />
      <Typography variant="h4" fontWeight={700}>Tabulator Portal</Typography>
      <Typography color="text.secondary">Tabulation tools are coming soon.</Typography>
      <Button variant="outlined" onClick={() => { window.location.href = `${API_BASE}/api/logout`; }}>
        Logout
      </Button>
    </Box>
  );
}
